{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-710000",
  "definition": "[710000] Notes - Corporate information",
  "sheetId": "NotesCorporateInformation",
  "label": "Notes - Corporate Information",
  "controls": [
    {
      "qname": "section:CorporateInformation",
      "label": "Corporate information",
      "type": "SectionHeader",
      "ui": { "control": "section-header", "level": 1 }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfCorporateInformationExplanatory",
      "label": "Disclosure of corporate information",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 15
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "section:FinancialReportingStatus",
      "label": "Financial reporting status",
      "type": "SectionHeader",
      "ui": { "control": "section-header", "level": 1 }
    },
    {
      "qname": "ssmt-mfrs:ExplanationOfReasonsForRestatementOfPreviousFinancialStatementsFiguresExplanatory",
      "label": "Explanation of reasons for the restatement of previous financial statements figures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8
      },
      "required": false,
      "validators": [],
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-mfrs:ExplanationOfReasonsForReclassificationOfPreviousFinancialStatementsFiguresExplanatory",
      "label": "Explanation of reasons for the reclassification of previous financial statements figures",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8
      },
      "required": false,
      "validators": [],
      "requiredIfCrossSheet": {
        "sheet": "scopeOfFiling",
        "field": "ssmt:DisclosureOnWhetherReclassificationOfPreviousFinancialStatementsChangedDueToChangesInAccountingStandards",
        "equals": "Yes"
      },
      "error": {
        "requiredCrossSheet": "When \"Disclosure on whether reclassification of previous financial statements changed due to changes in accounting standards\" is \"Yes\", then \"Explanation of reasons for the reclassification of previous financial statements figures\" MUST be reported."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    },
    {
      "qname": "ssmt-mfrs:ExplanationOfReasonsForUsingLongerOrShorterReportingPeriodExplanatory",
      "label": "Explanation of reasons for using longer or shorter reporting period",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      },
      "required": false,
      "validators": [],
      "requiredIfCrossSheet": {
        "sheet": "scopeOfFiling",
        "field": "ssmt:DisclosureOnWhetherCompanyChangedDurationOfFinancialReportingPeriod",
        "equals": "Yes"
      },
      "error": {
        "requiredCrossSheet": "When \"Description on whether company changed the duration of financial reporting period\" is \"Yes\", then \"Explanation of reasons for using longer or shorter reporting period\" MUST be reported."
      },
      "ContextPolicy": { "periodTemplate": "D_CUR", "allowedAxes": [] }
    }
  ]
}
